export default {"src":"/_next/static/media/logo-color-black.0744900c.svg","height":254,"width":1646};